@if (showPanel$ | async) {
  <mat-expansion-panel class="panel">
    <mat-expansion-panel-header>
      <mat-panel-title>{{ 'ASSOCIATIONS.ACCOUNT.TITLE' | translate }}</mat-panel-title>
    </mat-expansion-panel-header>
    @if (accountGroupInfo$ | async; as accountGroupInfo) {
      <crm-association-card
        [cardData]="accountGroupInfo"
        [showEditTagButton]="false"
        [showRemoveButton]="false"
        [actions]="accountGroupActions$ | async"
      >
      </crm-association-card>
    } @else {
      @if (isAccountGroupLoading()) {
        <button mat-stroked-button color="primary" class="button-create-account" type="button" disabled>
          <glxy-loading-spinner [size]="'small'"></glxy-loading-spinner>
        </button>
      } @else {
        <button mat-stroked-button color="primary" class="button-create-account" (click)="createAccount()">
          <mat-icon>add</mat-icon>
          {{ 'ASSOCIATIONS.ACCOUNT.CREATE_ACCOUNT' | translate }}
        </button>
        <p class="description">{{ 'ASSOCIATIONS.ACCOUNT.CREATE_DESCRIPTION' | translate }}</p>
      }
    }
  </mat-expansion-panel>
}
